import styled from 'styled-components';

export const EmbeddedContentStyles = styled.div`
  margin-bottom: 30px;

  .embedded-content-headline,
  .embedded-content-sub-headline {
    font-family: 'source-sans-pro', sans-serif;
  }
  .embedded-content-headline {
    font-size: 20px;
    font-weight: 800;
    margin-bottom: 10px;
    padding-bottom: 0;
  }
  .embedded-content-sub-headline {
    font-size: 18px;
    margin-bottom: 10px;
  }
  .body-content {
    padding-bottom: 0;
    padding-top: 0;
  }

  .video-container,
  .quiz-container {
    margin-bottom: 50px;
    h4,
    p {
      margin-bottom: 16px;
    }
    .disclaimer {
      padding-top: 30px;
    }
  }
  .quiz-container {
    p {
      margin-bottom: 16px;
    }
    iframe {
      border: none;
    }
  }
  .iframe-container {
    position: relative;
    overflow: hidden;
    padding-top: 56.25%; /* 16:9 */
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
    }
  }
`;

export default EmbeddedContentStyles;
